import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../styles/ProductDetailPage.css";
import {
  fetchproductDetailS,
  clearProductDetail,
} from "../redux/productDetailSlice";
import { useBreadcrumb } from "../hooks/useBreadcrumb";
import ProductContent from "../components/ProductContent";
import ProductGallery from "../components/ProductGallery";
import DiscoverSimilarStyle from "../components/DiscoverSimilarStyle";
import DontMissThese from "../components/DontMissThese";
import ProductTab from "../components/ProductTab";
import Footer from "../../../../components/Footer/Footer";
import ShareButton from "../components/ShareButton";
import ProductDetailBreadcrumbs from "../../../../components/Breadcrumbs/ProductDetailBreadcrumbs";
import PageNotFound from "../../../Error/PageNotFound";

const ProductDetail = () => {
  const { slug, sku } = useParams();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state) => state.productDetail
  );
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [isProductReady, setIsProductReady] = useState(false);

  /* FETCH PRODUCT */

  useEffect(() => {
    if (!slug) return;
    dispatch(fetchproductDetailS({ slug, sku }));
    return () => {
      dispatch(clearProductDetail());
    };
  }, [slug, sku, dispatch]);

  /* DEFAULT SIZE + COLOR */

  useEffect(() => {
    if (!data?.product_sizes?.length) return;
    const size =
      data.product_sizes.find((s) => s.id === data.selected_size_id) ||
      data.product_sizes[0];
    const product_media = data.product_images;
    setSelectedSize(size);
    setSelectedColor(product_media);
  }, [data, sku]);

  // const videoSource = { video_source: data.video_source ?? null };

  /* PRODUCT READY */

  useEffect(() => {
    if (!loading && data) {
      setIsProductReady(true);
    }
  }, [loading, data]);

  const breadcrumbPaths = useBreadcrumb(data);
  // if (error) {
  //   return <PageNotFound />;
  // }
  return (
    <>
      {/* TRANSPARENT LOADER */}
      {/* {loading && <ProductPageLoader />} */}

      {/* Breadcrumb */}
      <div className="root_br_head" style={{ position: "relative" }}>
        <ProductDetailBreadcrumbs
          paths={breadcrumbPaths}
          loading={loading}
          Skeleton={Skeleton}
        />

        <div className="product-title-row">
          <ShareButton />
        </div>
      </div>

      {/* PRODUCT PAGE */}
      <div className="product-page padding-0002">

        {/* LEFT GALLERY */}
        <ProductGallery
          data={data}
          selectedColor={selectedColor}
          loading={loading}
        />

        {/* RIGHT CONTENT */}
        <ProductContent
          productData={data}
          loading={loading}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
        />
      </div>

      {/* TABS */}
      {isProductReady && <ProductTab productDetails={data} />}
      {/* RELATED PRODUCTS */}
      {isProductReady && <DiscoverSimilarStyle />}
      {isProductReady && <DontMissThese />}

      <Footer />
    </>
  );
};

export default ProductDetail;